import { combineReducers } from '@reduxjs/toolkit';
import { reducer as forms } from 'redux-form';

import crudReducer from "./crudReducer";
import gridReducer from "./gridReducer";
import listReducer from "./listReducer";
import storageReducer from "./storageReducer";
import { RESET_STORE } from "../actions/storage";

const combinedReducer = combineReducers({
    form: forms,
    list: listReducer,
    grid: gridReducer,
    crud: crudReducer,
    storage: storageReducer,
});

const rootReducer = (state, action) => {
    if (action.type === RESET_STORE) {
        state = undefined;
    }
    return combinedReducer(state, action);
};

export default rootReducer;